import React, { FC } from 'react'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'

import dragIcon from '../../assets/icons/dragIcon.svg'

export const DrugStrip: FC = () => {
  const { spacing } = useTheme()

  return (
    <Box height={spacing(4)} display="flex" justifyContent="center" alignItems="center">
      <Box height={spacing(3)} width={spacing(3)}>
        <img src={dragIcon} alt={'drag'} draggable={false} />
      </Box>
    </Box>
  )
}
